import React,{ Component } from 'react';

import { getScrollTop } from '../../../shared/utils';

class ScrollWatcher extends Component {
  componentDidMount(){
    this.handleScroll = () => {

      this.props.onScroll(getScrollTop());
    };

    document.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount(){
    document.removeEventListener('scroll', this.handleScroll);
  }

  render(){
    return (
      <div ref={(c) => this.component = c} />
    )
  }
}

ScrollWatcher.defaultProps = {
  onScroll:() => {}
};

export default ScrollWatcher;



// WEBPACK FOOTER //
// ./src/shared/components/ScrollWatcher/index.js